import { Paragraph, TextRun } from 'docx'

const SectionHeader = ({ text, size, headingNumber }) =>
  new Paragraph({
    // style: 'sectionHeader',
    children: [
      new TextRun({
        text,
        bold: true,
        font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
        size,
        color: '000000',
      }),
    ],
    heading: headingNumber,
  })

export default SectionHeader
